<template>
  <div class="orderSubscriptionHistory">
      <div class="orderSummary">
    <div class="row">

        <template v-for="(order, index) in orderboxgroup">
            <div :key="index+'box'" class="col-6">
                <div class="orderSummaryLabel">
                    {{order.count > 1 ? `(${order.count}) Dozen` : ''}} {{order.box_name}}
                </div>
            </div>

            <div :key="index+'price'" class="col-6">
                <div class="orderSummaryPrice">
                    ${{getboxprice() * order.count | decimal}}
                </div>
            </div>
        </template>
    </div>
</div>

<div class="orderSummaryOtherCharges">
    <div class="row">
        <div class="col-6">
            <div class="orderSummaryLabel">
                DELIVERY
            </div>
        </div>

        <div class="col-6">
            <div class="orderSummaryPrice">
                ${{history.delivery_fee}}
            </div>
        </div>
        <div class="col-6">
            <div class="orderSummaryLabel">
                TAXES
            </div>
        </div>

        <div class="col-6">
            <div class="orderSummaryPrice">
                ${{history.tax_fee}}
            </div>
        </div>
        <div class="col-6">
            <div class="orderSummaryLabel">
                TOTAL
            </div>
        </div>

        <div class="col-6">
            <div class="orderSummaryPrice grandTotalPrice">
                ${{history.total}}
            </div>
        </div>
    </div>
</div>

<div class="orderCard">
    <img src="@/assets/img/visalogo.png" alt=""> ending in 9060 12/25
</div>
  </div>
</template>

<script>
/**
 * Mixins
 */
import {orderboxmixins} from '@/mixins/orderboxmixins'
import {ordermixins} from '@/mixins/ordermixins'

export default {
    mixins: [orderboxmixins, ordermixins],
    props : {
        orderboxeshistory : {
            type : Array,
            default : () => {
                return []
            }
        },
        history : {
            type : Object,
            default : () => {
                return null
            }
        }
    },
    computed : {
        orderboxgroup () {
            const boxes = this.orderboxeshistory.map(box => {
                box.id = box.box_id;

                return box;
            })
            const group = this.groupboxorder(boxes)

            return group;
        }
    },
    /**
     * run function after component rendered
     */
    mounted() {
        // get summary compuration
        this.computeordersummary();
    }
    
}
</script>

<style>

</style>